import React from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { updateLocationFilterList } from '../../../actions'
import { employeeDashboardStore as store } from '../../../../store';
import FilterWithHeaderSection from '../FilterWithHeaderSection';
import './LocationFilter.scss'

function LocationFilter() {
    const filters = useSelector(state => state.filters);

    const handleLocationChange = ({selectedItems, isTransferIncluded}) => {
        store.dispatch(updateLocationFilterList({ filters: selectedItems, isTransferIncluded: isTransferIncluded}));
	};

    return (
        <div className='location-filter-wrapper'>
            <FilterWithHeaderSection 
                title="Locations"
                items={filters.location.filters}
                onChange={handleLocationChange}
                expandIcon={(<FontAwesomeIcon icon={["far", "chevron-up"]}/>)}
            />
        </div>
    );
}


export default LocationFilter;